import { render, staticRenderFns } from "./Stockpurchase.vue?vue&type=template&id=7f595b11&scoped=true"
import script from "./Stockpurchase.vue?vue&type=script&lang=js"
export * from "./Stockpurchase.vue?vue&type=script&lang=js"
import style0 from "./Stockpurchase.vue?vue&type=style&index=0&id=7f595b11&prod&scoped=true&lang=css"
import style1 from "./Stockpurchase.vue?vue&type=style&index=1&id=7f595b11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f595b11",
  null
  
)

export default component.exports